import { useAppDispatch } from "../../hooks/useAppDispatch";
import { util } from "../../store/orders/orders.api";

export const useInvalidateOrder = () => {
    const dispatch = useAppDispatch()
    return () => dispatch(util.invalidateTags(["Order"]))
}